import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

interface IconWrapperProps {
  uploading?: boolean
}

export const ImageWrapper = styled.div<IconWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${Spacing.S8};
`

export const Footer = styled.footer<IconWrapperProps>`
  position: relative;
  z-index: 1;
  text-align: center;
`
